/**
 * Legal copy version shown at accept time and stored on partner applications.
 * Bump when the terms HTML changes in a way that needs a new acceptance.
 * Pricing figures are not part of this version — they live on the Pricing page.
 */
export const TERMS_VERSION = '2.1';
